export default __webpack_public_path__ + "static/media/minigraphs.2a877977.png";